import React from 'react';
import styled from 'styled-components/native';
import { AppCardView } from '@/components/base/app.card.view';
import { AppSpinner } from '@/components/base/app.spinner';
import { AppTextView } from '@/components/base/app.text.view';
import { Box } from '@/components/base/box';

interface Props {
  text: string;
}
function BaseStateView({ text }: Props) {
  return (
    <Container>
      <CardView>
        <Middle>
          <CallText text={text} textColor="black_light" />
          <AppSpinner />
        </Middle>
      </CardView>
    </Container>
  );
}

const CallText = styled(AppTextView)`
  margin-left: 15px;
  user-select: none;
`;

const Container = styled(Box)`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  position: absolute;
`;

const Middle = styled(Box)`
  flex-direction: row-reverse;
  padding: 10px;
  border-radius: 10px;
`;

const CardView = styled(AppCardView)`
  border-radius: 10px;
`;

export const CallStateView = React.memo(BaseStateView);
